import { render } from "./TypeText.vue?vue&type=template&id=9404267a&ts=true"
import script from "./TypeText.vue?vue&type=script&lang=ts"
export * from "./TypeText.vue?vue&type=script&lang=ts"

import exportComponent from "/home/hugo/Proyectos/TierraMedia2.0/edoras/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__